module.exports = __webpack_public_path__ + "img/horizontal_3_1_6000.74da89ac.png";